import { REDUX_MAP_TYPES } from './action'

const initialState = {
  mapForm: {
    pickupRoute: {},
    deliveryRoute: {},
    pickupStops: [],
    deliveryStops: []
  }
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case REDUX_MAP_TYPES.RESET:
      return initialState
    case REDUX_MAP_TYPES.SELECTED_DISTANCE:
      return {
        ...state,
        selectedDistance: action.payload
      }
    case REDUX_MAP_TYPES.ROUTE_SELECTABLE:
      return {
        ...state,
        routeSelectable: action.payload
      }
    case REDUX_MAP_TYPES.SELECTED_ROUTE:
      return {
        ...state,
        selectedRoute: action.payload
      }
    case REDUX_MAP_TYPES.MAP_FORM:
      return {
        ...state,
        mapForm: action.payload
      }
    case REDUX_MAP_TYPES.EDIT_MODE:
      return {
        ...state,
        editMode: action.payload
      }
    default:
      return state
  }
}
